"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fieldStyles = require("./_fieldStyles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SelectField(props) {
  return _react.default.createElement(_fieldStyles.FieldContainer, null, _react.default.createElement("div", {
    className: "label"
  }, props.label), _react.default.createElement(_fieldStyles.Select, {
    name: props.name,
    defaultValue: props.value,
    onChange: props.onChange
  }, _react.default.createElement("option", {
    value: ""
  }, "Please Select"), props.options.map((opt, index) => {
    return _react.default.createElement("option", {
      key: index,
      value: opt
    }, opt);
  })), props.error && _react.default.createElement("div", {
    className: "error"
  }, props.error));
}

SelectField.propTypes = {
  label: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.any,
  options: _propTypes.default.array,
  error: _propTypes.default.any,
  onChange: _propTypes.default.func.isRequired
};
SelectField.defaultValue = {
  options: []
};
var _default = SelectField;
exports.default = _default;